<template>
  <div>
    <v-col cols="12" style="text-align: right">
      <v-btn
        color="info"
        dark
        @click="editPackage = true"
        v-if="!editPackage && roles.update_package"
        >Edit</v-btn
      >
      <v-btn color="info" v-else disabled>Edit</v-btn>
      &nbsp;
      <v-btn
        color="success"
        dark
        @click="saveData"
        v-if="editPackage && roles.update_package"
        >Save</v-btn
      >
      <v-btn color="success" v-else disabled>Save</v-btn>
      &nbsp;
      <v-btn color="orange" dark @click="cancelData()">Close</v-btn>
    </v-col>

    <v-col cols="12" v-if="informText != ''">
      <v-alert type="error">{{ informText }}</v-alert>
    </v-col>

    <v-row style="text-align: left">
      <v-col cols="4">
        <template v-if="editPackage">
          <v-text-field
            label="Package Name"
            outlined
            dense
            v-model="packageData.package_name"
            hide-details
          ></v-text-field>
        </template>

        <template v-else>
          <b>Package Name:</b> {{ packageData.package_name }}
        </template>
      </v-col>

      <v-col cols="4"><b>Supplier:</b> {{ packageData.supplier }}</v-col>
      <v-col cols="4"><b>Base cost:</b> ${{ packageData.base_cost }}</v-col>
      <v-col cols="4"
        ><b>Total quantity:</b> {{ packageData.total_quantity }}</v-col
      >
      <v-col cols="4"><b>Sold:</b> {{ packageData.sold }}</v-col>
      <v-col cols="4"></v-col>

      <v-col cols="4"><b>Status:</b> {{ packageData.status }}</v-col>
      <v-col cols="4">
        <template v-if="editPackage">
          <b
            >Tracking number:
            <v-btn
              small
              color="info"
              style="margin-bottom: 5px"
              @click="addTracking()"
              >Add</v-btn
            >
          </b>
          <div v-for="(i, index) of packageData.tracking_numbers" :key="index">
            <v-row style="margin-bottom: 5px">
              <v-text-field
                label="Tracking Number"
                outlined
                dense
                v-model="i.tracking_number"
                hide-details
                style="margin-right: 5px"
              ></v-text-field>

              <v-text-field
                label="Carrier"
                outlined
                dense
                v-model="i.carrier"
                hide-details
                style="margin-right: 5px"
              ></v-text-field>

              <v-btn small color="red" @click="delTracking(i)" dark
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </v-row>
          </div>
        </template>

        <template v-else>
          <b>Tracking number:</b>
          <div v-for="(i, index) of packageData.tracking_numbers" :key="index">
            {{ i.tracking_number }} - {{ i.carrier }}
          </div>
        </template>
      </v-col>
    </v-row>

    <table width="100%" style="text-align: left" class="table table-bordered">
      <thead>
        <tr>
          <th>#</th>
          <th>Mockup</th>
          <th>Product</th>
          <th>Variant</th>
          <th>Current Location</th>
          <th>Location Type</th>
          <th>In Stock</th>
          <th>Sold</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(i, indexi) of productPackage">
          <!-- In dong dau tien cua bang -->
          <tr :key="indexi">
            <td :rowspan="i.location">{{ indexi + 1 }}</td>
            <td :rowspan="i.location">
              <img :src="i.mockup" width="70px" />
            </td>
            <td :rowspan="i.location">
              <div>{{ i.product_code }}</div>
              <div>{{ i.title }}</div>
            </td>

            <td :rowspan="i.variants[0].locations.length">
              {{ i.variants[0].variantName }}
            </td>

            <td>{{ i.variants[0].locations[0].current_location }}</td>
            <td>{{ i.variants[0].locations[0].location_type }}</td>
            <td>{{ i.variants[0].locations[0].in_stock }}</td>
            <td>{{ i.variants[0].locations[0].sold }}</td>
            <td>
              <v-btn
                color="purple"
                @click="
                  codeSelected =
                    i.variants[0].locations[0].unique_product_group_code
                "
                dark
                small
                v-if="roles.update_package"
                >Change Location</v-btn
              >
            </td>
          </tr>

          <template v-for="(j, indexj) of i.variants">
            <template v-if="indexj != 0">
              <!-- In dong dau tien cua variant tiep theo -->
              <tr :key="indexj">
                <td :rowspan="j.locations.length">{{ j.variantName }}</td>
                <td>{{ j.locations[0].current_location }}</td>
                <td>{{ j.locations[0].location_type }}</td>
                <td>{{ j.locations[0].in_stock }}</td>
                <td>{{ j.locations[0].sold }}</td>
                <td>
                  <v-btn
                    color="purple"
                    @click="
                      codeSelected = j.locations[0].unique_product_group_code
                    "
                    dark
                    small
                    v-if="roles.update_package"
                    >Change Location</v-btn
                  >
                </td>
              </tr>
              <template v-for="(k, indexk) of j.locations">
                <!-- In cac location data tiep theo cua variant dang duyet -->
                <tr :key="indexj + '-' + indexk" v-if="indexk != 0">
                  <template>
                    <td>{{ k.current_location }}</td>
                    <td>{{ k.location_type }}</td>
                    <td>{{ k.in_stock }}</td>
                    <td>{{ k.sold }}</td>
                    <td>
                      <v-btn
                        color="purple"
                        @click="codeSelected = k.unique_product_group_code"
                        dark
                        small
                        v-if="roles.update_package"
                        >Change Location</v-btn
                      >
                    </td>
                  </template>
                </tr>
              </template>
            </template>
            <template v-else>
              <template v-for="(l, indexl) of j.locations">
                <!-- In cac location data tiep theo cua variant dau tien -->
                <tr
                  :key="indexi + '-' + indexj + '-' + indexl"
                  v-if="indexl != 0"
                >
                  <td>
                    {{ l.current_location }}
                  </td>
                  <td>{{ l.location_type }}</td>
                  <td>{{ l.in_stock }}</td>
                  <td>{{ l.sold }}</td>
                  <td>
                    <v-btn
                      color="purple"
                      @click="codeSelected = l.unique_product_group_code"
                      dark
                      small
                      v-if="roles.update_package"
                      >Change Location</v-btn
                    >
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
      </tbody>
    </table>

    <BaseDialog
      :active.sync="DialogChangeLocation"
      dialog_name="Change Location"
    >
      <DialogChangeLocation
        :item="productSelected"
        :locationData="locationData"
        :packageID="packageID"
      />
    </BaseDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import Amplify from "aws-amplify";
import BaseDialog from "../Common/c-base-dialog";
import DialogChangeLocation from "./c-dialog-package-change-location.vue";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PackageDetail",

  components: {
    BaseDialog,
    DialogChangeLocation,
  },

  props: {
    packageID: String,
    supplierData: Array,
  },

  data: () => ({
    DialogChangeLocation: false,
    packageData: [],
    locationData: [],
    loading: false,
    search: null,

    informText: "",
    productSelected: [],
    editPackage: false,
    roles: [],
    productPackage: [],
    codeSelected: "",
  }),

  watch: {
    productSelected() {
      console.log("productSelected: ", this.productSelected);
    },

    codeSelected() {
      this.productSelected = this.packageData.products[this.codeSelected];
      this.DialogChangeLocation = !this.DialogChangeLocation;
    },
  },

  created() {
    this.$root.$refs.packageListDetail = this;
  },

  methods: {
    async loadData() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "package-loadData"
      );
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "packages/" + this.packageID, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            // If request is good...
            console.log("response: ", response);
            this.packageData = response.data.data.package;
            this.locationData = response.data.data.locations;
            this.packageData.created_time = moment(
              this.packageData.created_time
            ).format("YYYY-MM-DD HH:MM:SS");
            this.convertData();
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log("currentSession user-loadData-undefined: ", currentSession);
      }
      this.loading = false;
    },

    convertData() {
      //convert object products sang list product
      var temp = [];
      this.productPackage = [];
      for (var i in this.packageData.products) {
        temp.push(this.packageData.products[i]);
      }

      //lay ra code cua cac san pham trong list
      var setProd = new Set();
      for (var prod of temp) {
        setProd.add(prod.product_code);
      }

      //convert data
      for (var code of setProd) {
        var prodItem = {};
        var filter = temp.filter((t) => t.product_code == code);
        if (filter.length > 0) {
          prodItem["title"] = filter[0].title;
          prodItem["product_code"] = filter[0].product_code;
          prodItem["mockup"] = filter[0].mockup;
          prodItem["variants"] = []; //du lieu variant va cac location cua variant do
          prodItem["location"] = 0; //dung lam rowspan

          //var variantSet = [];
          var currentVariant = { variantName: null, locations: [] };

          for (var fi of filter) {
            var locationData = {
              current_location: fi.current_location,
              in_stock: fi.in_stock,
              location_type: fi.location_type,
              sold: fi.sold,
              unique_product_group_code: fi.unique_product_group_code,
            };
            //prodItem["location"].push(locationData);
            prodItem["location"] += 1;

            if (currentVariant.variantName != fi.variant) {
              if (currentVariant.variantName) {
                prodItem["variants"].push(
                  JSON.parse(JSON.stringify(currentVariant))
                );
              }
              currentVariant = { variantName: null, locations: [] };
              currentVariant.variantName = fi.variant;
              currentVariant.locations.push(locationData);
            } else {
              currentVariant.locations.push(locationData);
            }
          }
          prodItem["variants"].push(JSON.parse(JSON.stringify(currentVariant)));
        }

        this.productPackage.push(prodItem);
      }
      console.log("this.productPackage: ", this.productPackage);
    },

    async saveData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "package-saveData"
      );
      if (currentSession.accessToken) {
        await axios({
          method: "PUT",
          url: window.domain + "packages/" + this.packageID,
          headers: { Authorization: currentSession.accessToken },
          data: {
            package_name: this.packageData.package_name,
            tracking_numbers: this.packageData.tracking_numbers,
          },
        }).then((response) => {
          console.log("response: ", response);
          if (response.data.error_message != "") {
            this.informText = response.data.error_message;
          } else {
            this.cancelData(true);
          }
        });
      }
    },

    addTracking() {
      var item = {
        carrier: "",
        tracking_number: "",
      };

      this.packageData.tracking_numbers.push(item);
    },

    delTracking(item) {
      this.packageData.tracking_numbers =
        this.packageData.tracking_numbers.filter((t) => t != item);
    },

    turnOffDialog(reload) {
      console.log("package detail: ", reload);
      this.DialogChangeLocation = false;
      if (reload) {
        this.loadData();
      }
    },

    cancelData(reload) {
      if (reload) {
        this.$root.$refs.packageList.turnOffDialog(true);
      } else {
        this.$root.$refs.packageList.turnOffDialog();
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("package");
    if (this.roles.read_package) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    await this.loadData();
  },
};
</script>

<style lang="scss" scoped>
</style>